export default "__VITE_PUBLIC_ASSET__dcbe9771__"